module.exports = __webpack_public_path__ + "images/icon-72.62735b70b14f67b3de45ddc4ea8313d9.png";